import { View, Text } from 'tamagui'

export function ActivityDetails() {
  return (
    <View gap="$spacing-inset-xs">
      <View
        backgroundColor="$neutral-100"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
      >
        <Text
          color="$neutral-800"
          fontSize="$font-size-xxxs"
          opacity={0.64}
          lineHeight={18}
        >
          QUANTIDADE DE QUESTÕES
        </Text>
        <Text
          color="$neutral-800"
          fontSize="$font-size-xs"
          fontWeight={600}
          lineHeight={24}
        >
          20
        </Text>

        <View flexDirection="row" justifyContent="space-between" marginTop={20}>
          <View>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              TENTATIVAS
            </Text>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              0 de 3 tentativas
            </Text>
          </View>

          <View>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              NOTA MÍNIMA
            </Text>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              70
            </Text>
          </View>
        </View>
      </View>

      <View
        backgroundColor="$neutral-100"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
      >
        <Text
          color="$neutral-800"
          fontSize="$font-size-xxxs"
          opacity={0.64}
          lineHeight={18}
        >
          SEU RESULTADO
        </Text>
        <Text
          color="$neutral-800"
          fontSize="$font-size-xs"
          fontWeight={600}
          lineHeight={24}
        >
          -
        </Text>
      </View>
    </View>
  )
}
